<template>
  <div class="additional-services">
    <h2 class="additional-services-title">{{ $t("additionalsNice") }}</h2>
    <div class="accordion accordion-flush" id="accordionadd">
      <template v-for="(cat, idx) in categories" :key="'category' + idx">
        <div class="accordion-item">
          <h2 class="accordion-header" :id="'heading' + idx">
            <button @click="this.scrollToElement('accordionadd')" class="accordion-button collapsed p-0" type="button"
              data-bs-toggle="collapse" :data-bs-target="'#category' + idx" aria-expanded="false"
              :aria-controls="'category' + idx">
              {{ cat.category }}
            </button>
          </h2>
          <div class="accordion-collapse collapse" :id="'category' + idx" :aria-labelledby="'heading' + idx"
            data-bs-parent="#accordionadd">
            <div class="accordion-body px-0">
              <!-- <div class="row mb-3">
                <div class="col-6 col-md-5">
                  <h4 class="label">Artikel</h4>
                </div>
                <div class="col-2 col-md-3">
                  <h4 class="label">Price</h4>
                </div>
                <div class="col-2">
                  <h4 class="label">Anzahl</h4>
                </div>
                <div class="col-2 text-right text-end">
                  <h4 class="label">Summe</h4>
                </div>
              </div> -->
              <template v-for="(additional, idx) in additionals" :key="'additional' + idx">
                <template v-if="additional.category_id == cat.category_id">
                  <AdditionalListItem v-bind="additional" @update="updateAdditional" />
                </template>
              </template>
            </div>
          </div>
        </div>
      </template>
    </div>
    <div class="row service additional-services-footer">
      <div class="col-6">
        <h4>{{ $t("totalshort") }}: </h4>
      </div>
      <div class="col-6 text-right text-end">
        <h5> {{ toPrice(total) }}</h5>
      </div>
    </div>
    <div class="row additional-services-next-step justify-content-end">
      <div class="col-auto">
        <button class="btn btn-primary btn-gradient btn-next" @click="
          logval(progress);
        progress.step = 2;
        // progress.contact.show = true;
        progress.contact.show = showContact();
        //showContact();
        progress.additionals.show = false;
        progress.additionals.overview = true;
        scrollToElement(progress.additionals.name);">
          {{ $t("next") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>

import AdditionalListItem from "./AdditionalListItem.vue";

export default {
  inject: ["reservation", "progress"],
  name: "Additionals",

  components: {
    AdditionalListItem,
  },
  data() {
    return {
      additionals: null,
      categories: [],
      total: 0,
      //progress: progress,
      //reservation: Reservation,
    };
  },

  created() {

    // console.log("Value of val is: " + this.reservation.test);
    this.axios.post(this.url + "/rest/v1/additionals/").then((response) => {
      this.status = response.status;
      this.additionals = response.data;
      // there is sessionId, not needed
      delete this.additionals.sessionId;





      // categories
      for (var idx in this.additionals) {
        const isCatPresent = this.categories.some((o) => o.category_id === this.additionals[idx].category_id);
        if (!isCatPresent) {
          this.categories.push({
            category_id: this.additionals[idx].category_id,
            category_sorting: this.additionals[idx].category_sorting,
            category: this.additionals[idx].category
          })
        }
      }

      this.categories.sort((a, b) => a.category_sorting - b.category_sorting);
      // console.log(this.categories);

    });
  },

  computed: {
    // for changing prices for daog and car
    nightsChanged() {
      return this.reservation.nights;
    }
  },
  watch: {
    nightsChanged() {
      // change price for dog and cars based on uid 1 and 13
      for (let [key] of Object.entries(this.additionals)) {
        // dog price
        if (this.additionals[key].uid == 13) {
          this.additionals[key].price = this.additionals[key].price * this.reservation.nights;
        }
        // car price
        if (this.additionals[key].uid == 1) {
          this.additionals[key].price = this.additionals[key].price * this.reservation.nights;
        }

      }
    }
  },



  methods: {
    showContact() {
      if (this.progress.contact.overview == false) {
        return true
      } else {
        return false
      }
    },
    logval(e) {
      console.log(e);
    },
    totalAdditionals() {
      var additionalSum = 0.0;
      this.reservation.additionals.forEach((obj) => {
        additionalSum += obj.amount * obj.price;
      });
      return additionalSum;
    },
    updateTotal() {
      var additionalSum = 0;
      console.log(this.reservation.additionals.length);
      if (this.reservation.additionals.length > 0) {
        this.reservation.additionals.forEach((obj) => {
          additionalSum += obj.amount * obj.price;
        });
        this.reservation.totalAdditionals = additionalSum;
        this.total = this.reservation.totalAdditionals;
      }
    },

    updateAdditional(a) {
      console.log(a);
      var found = false;
      //localStorage.setItem("reservationData", JSON.stringify(this.reservation));
      this.reservation.additionals.find((o, i) => {
        if (o.uid === a.uid) {
          this.reservation.additionals[i].amount = a.selected;
          //Vue.set(this.reservation.additionals[i], "amount", a.selected);
          var sum = a.selected * this.reservation.additionals[i].price;
          this.reservation.additionals[i].sum = sum;
          //Vue.set(this.reservation.additionals[i], "sum", sum);
          found = true;

          // if amount is set to 0 then remove
          if (this.reservation.additionals[i].amount == 0) {
            // remove it
            this.reservation.additionals.splice(i, 1);
          }
          this.updateTotal();
          return true; // stop searching
        }
      });
      if (found == false) {
        // new record
        this.reservation.additionals.push({
          uid: a.uid,
          title: a.title,
          price: a.price,
          amount: a.selected,
          sum: a.price * a.selected,
        });
        this.updateTotal();
      }
    },
  },
};
</script>
